module.exports = __webpack_public_path__ + "static/img/患者管理@2x2.c7113660.png";